(() => {
  // =========================
  // CONFIG
  // =========================
  const PASS = "KOTMO2026"; // 🔑 <-- change ici
  const KEY = "mg_gate_ok_v1"; // clé localStorage
  const TITLE = "Accès restreint";
  const SUBTITLE = "Entrez le mot de passe pour accéder à l’outil.";

  const gate = document.getElementById("mgGate");
  const wrap = document.getElementById("mgProtectedWrap");
  if (!gate || !wrap) return;

  function unlock() {
    gate.innerHTML = "";
    wrap.style.display = "";
    try { localStorage.setItem(KEY, "1"); } catch {}
  }

  function lock() {
    try { localStorage.removeItem(KEY); } catch {}
    location.reload();
  }

  // Déjà validé ?
  try {
    if (localStorage.getItem(KEY) === "1") {
      unlock();
      return;
    }
  } catch {}

  // UI gate
  gate.innerHTML = `
    <div style="max-width:560px;margin:38px auto;padding:18px 18px 16px;border:1px solid rgba(0,0,0,.12);border-radius:14px;background:#fff;">
      <div style="font-weight:700;font-size:18px;margin-bottom:10px;">${escapeHtml(TITLE)}</div>
      <div style="opacity:.75;font-size:14px;margin-bottom:12px;">${escapeHtml(SUBTITLE)}</div>

      <div style="display:flex;gap:10px;align-items:center;">
        <input id="mgPass"
          type="password"
          placeholder="Mot de passe"
          autocomplete="current-password"
          style="flex:1;padding:12px 14px;border:1px solid rgba(0,0,0,.18);border-radius:10px;font-size:14px;outline:none;"
        />
        <button id="mgPassBtn" type="button"
          style="padding:12px 14px;border-radius:10px;border:1px solid rgba(0,0,0,.18);background:#111;color:#fff;cursor:pointer;font-size:14px;">
          OK
        </button>
      </div>

      <div id="mgPassErr" style="color:#b00020;font-size:13px;margin-top:10px;display:none;">
        Mot de passe incorrect.
      </div>

      <div style="margin-top:12px;opacity:.65;font-size:12px;line-height:1.35;">
        Accès mémorisé sur cet appareil (localStorage). Pour révoquer : supprimer les données du site ou utiliser le bouton ci-dessous.
      </div>

      <div style="margin-top:10px;display:flex;justify-content:flex-end;">
        <button id="mgGateReset" type="button"
          style="padding:9px 12px;border-radius:10px;border:1px solid rgba(0,0,0,.14);background:#fff;cursor:pointer;font-size:13px;">
          Réinitialiser l’accès
        </button>
      </div>
    </div>
  `;

  const input = document.getElementById("mgPass");
  const btn = document.getElementById("mgPassBtn");
  const err = document.getElementById("mgPassErr");
  const reset = document.getElementById("mgGateReset");

  function showErr() {
    err.style.display = "block";
    input.focus();
    input.select();
  }

  function check() {
    const v = (input.value || "").trim();
    if (v === PASS) unlock();
    else showErr();
  }

  btn.addEventListener("click", check);
  input.addEventListener("keydown", (e) => {
    if (e.key === "Enter") check();
  });

  reset.addEventListener("click", () => lock());

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, (m) => ({
      "&":"&amp;",
      "<":"&lt;",
      ">":"&gt;",
      '"':"&quot;",
      "'":"&#039;"
    }[m]));
  }
})();